import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';
import auth from '@/app/store/auth/auth';
import layout from '@/app/store/layout/layout';
import account from '@/app/store/account/account';
import billing from '@/app/store/billing/billing';
import app from '@/app/store/app/app';
import fund from '@/app/store/fund/fund';
import toolkit from '@/app/store/toolkit/toolkit';
import wizard from '@/app/modules/wizard/store/index';

Vue.use(Vuex);

function customizer(objValue, srcValue) {
  if (_.isObject(srcValue) && srcValue.replace) {
    delete srcValue.replace;
    return {
      ...objValue,
      ...srcValue,
    };
  }

  if (_.isObject(srcValue) && _.isDate(srcValue)) {
    return srcValue;
  }
  return undefined;
}
function performUpdate(state, newState) {
  return _.mergeWith(_.cloneDeep(state), _.cloneDeep(newState), customizer);
}

export const actions = {
  updateState(context, { state, newState }) {
    return performUpdate(state, newState);
  },
};

export const defaultConfig = {
  actions,
  modules: {
    auth,
    layout,
    account,
    billing,
    app,
    fund,
    toolkit,
    wizard,
  },
  strict: process.env.NODE_ENV !== 'production',
};


export function createStore(config) {
  return new Vuex.Store(config);
}


export default createStore(defaultConfig);
